import { motion } from 'framer-motion';
import { IconGauge } from '../components/ui/Icons.tsx';

const EASE = [0.22, 1, 0.36, 1] as const;

const STATS = [
  { label: 'Active campaigns', value: '—' },
  { label: 'Spend (7d)', value: '—', risk: true },
  { label: 'Leads (7d)', value: '—' },
  { label: 'Pending approvals', value: '—' },
];

/**
 * Feature 7. Framed as what the agent did and will do next — not an analytics dashboard.
 * Wired to live data once metrics_daily / agent_actions carry rows.
 */
export function CommandCenter() {
  return (
    <div className="lx-page lx-scroll">
      <div className="lx-page-inner">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.45, ease: EASE }}
        >
          <span className="lx-eyebrow" style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
            <IconGauge size={13} /> Overview
          </span>
          <h1 style={{ fontSize: 'clamp(22px, 5vw, 28px)', marginTop: 8 }}>Command center</h1>
          <p className="lx-muted" style={{ margin: '6px 0 0', maxWidth: '38rem' }}>
            What your agent is running, what it spent, and what it needs you to decide.
          </p>
        </motion.div>

        <div className="lx-stats">
          {STATS.map((s, i) => (
            <motion.div
              key={s.label}
              className="lx-stat"
              initial={{ opacity: 0, y: 14 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.4, delay: 0.06 + i * 0.06, ease: EASE }}
            >
              <span className="lx-eyebrow">{s.label}</span>
              <b style={{ color: s.risk ? 'var(--lx-risk-spend)' : 'var(--lx-text)' }}>{s.value}</b>
            </motion.div>
          ))}
        </div>

        <motion.p
          className="lx-empty-note"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.4, delay: 0.34 }}
        >
          No campaigns yet. Start one from the workspace — nothing here spends money without an
          explicit approval from you.
        </motion.p>
      </div>
    </div>
  );
}
